import gql from 'graphql-tag'

export const patientQueryById = gql`
  query patient($patientId: ID!) {
    patient(patientId: $patientId) {
      _id
      nickname
      petname
      username
      gender
      patientState
      healthCareTeamId
      joinDays
      cdeInfo {
        _id
        nickname
        avatar
      }
      doctorInfo {
        _id
        nickname
        avatar
      }
      hospital{
        _id
        name
        institutionName
        institutionId
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/modules/birthday/actions/queries.js